/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */

import { InfoCircledIcon } from '@radix-ui/react-icons';

import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';

const StatusPopoverInfo = () => {
    return (
        <Popover>
            <PopoverTrigger asChild>
                <Button variant="ghost" size="none" color="gray">
                    <InfoCircledIcon />
                    <span className="sr-only">Event description</span>
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-80">
                <div className="grid gap-4">
                    <div className="space-y-2">
                        <h4 className="font-medium leading-none">Status Event Types</h4>
                        <p className="text-sm text-muted-foreground">
                            Your webhook will receive all of the following status events:
                        </p>
                    </div>
                    <div className="space-y-4">
                        <div>
                            <h5 className="text-sm font-medium">status.execution.started</h5>
                            <p className="text-xs text-muted-foreground mt-1">
                                Triggered when a new execution begins. You'll receive this at the start of any suite
                                execution.
                            </p>
                        </div>

                        <div>
                            <h5 className="text-sm font-medium">status.run.ended</h5>
                            <p className="text-xs text-muted-foreground mt-1">
                                Triggered when an individual run within an execution completes. This helps track
                                progress of a suite execution.
                            </p>
                        </div>

                        <div>
                            <h5 className="text-sm font-medium">status.execution.ended</h5>
                            <p className="text-xs text-muted-foreground mt-1">
                                Triggered when the entire execution completes. This indicates all runs within the
                                execution have finished.
                            </p>
                        </div>

                        <div>
                            <h5 className="text-sm font-medium">status.run.reviewed</h5>
                            <p className="text-xs text-muted-foreground mt-1">
                                Triggered when a run has been manually reviewed by an operator.
                            </p>
                        </div>
                    </div>
                </div>
            </PopoverContent>
        </Popover>
    );
};

export default StatusPopoverInfo;
